exports.Routes = {
  Done: (query) => ({ 
      pathname: "/Done", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/Done",
          Object.keys(query),
          Object.values(query)
        )
      : "/Done",
    }),
  SelectElement: (query) => ({ 
      pathname: "/SelectElement", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/SelectElement",
          Object.keys(query),
          Object.values(query)
        )
      : "/SelectElement",
    }),
  TriggerSettings: (query) => ({ 
      pathname: "/TriggerSettings", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/TriggerSettings",
          Object.keys(query),
          Object.values(query)
        )
      : "/TriggerSettings",
    }),
  NotFound: (query) => ({ 
      pathname: "/404", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/404",
          Object.keys(query),
          Object.values(query)
        )
      : "/404",
    }),
  OfflineComponent: (query) => ({ 
      pathname: "/_offline", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/_offline",
          Object.keys(query),
          Object.values(query)
        )
      : "/_offline",
    }),
  BlitzFunctionSelfTest: (query) => ({ 
      pathname: "/_self-test/blitz-function", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/_self-test/blitz-function",
          Object.keys(query),
          Object.values(query)
        )
      : "/_self-test/blitz-function",
    }),
  ClientSideSelfTest: (query) => ({ 
      pathname: "/_self-test/client-side", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/_self-test/client-side",
          Object.keys(query),
          Object.values(query)
        )
      : "/_self-test/client-side",
    }),
  ServerSideSelfTest: (query) => ({ 
      pathname: "/_self-test/server-side", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/_self-test/server-side",
          Object.keys(query),
          Object.values(query)
        )
      : "/_self-test/server-side",
    }),
  AcceptInvitePage: (query) => ({ 
      pathname: "/accept-invite", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/accept-invite",
          Object.keys(query),
          Object.values(query)
        )
      : "/accept-invite",
    }),
  AdminApplicationConfigurationToggle: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/configuration-toggle", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/configuration-toggle",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/configuration-toggle",
    }),
  AdminApplicationEntitlements: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/entitlements", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/entitlements",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/entitlements",
    }),
  AdminApplicationFeatureFlags: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/feature-flags", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/feature-flags",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/feature-flags",
    }),
  TestPage: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/formTest", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/formTest",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/formTest",
    }),
  AdminApplication: (query) => ({ 
      pathname: "/admin/applications/[applicationId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]",
    }),
  AdminApplicationLocalizationLocale: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/localization/[locale]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/localization/[locale]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/localization/[locale]",
    }),
  AdminApplicationLocalization: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/localization", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/localization",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/localization",
    }),
  AdminApplicationProducts: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/products", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/products",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/products",
    }),
  AdminApplicationTransfer: (query) => ({ 
      pathname: "/admin/applications/[applicationId]/transfer", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications/[applicationId]/transfer",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications/[applicationId]/transfer",
    }),
  AdminApplications: (query) => ({ 
      pathname: "/admin/applications", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/applications",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/applications",
    }),
  AdminBotUser: (query) => ({ 
      pathname: "/admin/bot-users/[botUserId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/bot-users/[botUserId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/bot-users/[botUserId]",
    }),
  AdminBotUsers: (query) => ({ 
      pathname: "/admin/bot-users", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/bot-users",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/bot-users",
    }),
  AdminDownloadPaywall: (query) => ({ 
      pathname: "/admin/download-paywall", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/download-paywall",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/download-paywall",
    }),
  AdminEntitlement: (query) => ({ 
      pathname: "/admin/entitlements/[entitlementId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/entitlements/[entitlementId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/entitlements/[entitlementId]",
    }),
  AdminEntitlements: (query) => ({ 
      pathname: "/admin/entitlements", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/entitlements",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/entitlements",
    }),
  AdminFeatureFlag: (query) => ({ 
      pathname: "/admin/feature-flags/[featureFlag]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/feature-flags/[featureFlag]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/feature-flags/[featureFlag]",
    }),
  AdminFeatureFlags: (query) => ({ 
      pathname: "/admin/feature-flags", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/feature-flags",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/feature-flags",
    }),
  AdminHome: (query) => ({ 
      pathname: "/admin", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin",
    }),
  AdminOrganizationAddMember: (query) => ({ 
      pathname: "/admin/organizations/[organizationId]/add-member", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/organizations/[organizationId]/add-member",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/organizations/[organizationId]/add-member",
    }),
  AdminOrganization: (query) => ({ 
      pathname: "/admin/organizations/[organizationId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/organizations/[organizationId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/organizations/[organizationId]",
    }),
  AdminOrganizationSetupSubscription: (query) => ({ 
      pathname: "/admin/organizations/[organizationId]/set-subscription", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/organizations/[organizationId]/set-subscription",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/organizations/[organizationId]/set-subscription",
    }),
  AdminOrganizations: (query) => ({ 
      pathname: "/admin/organizations", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/organizations",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/organizations",
    }),
  AdminPaywall: (query) => ({ 
      pathname: "/admin/paywalls/[paywallId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/paywalls/[paywallId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/paywalls/[paywallId]",
    }),
  AdminPaywallLocalizableStringRequirement: (query) => ({ 
      pathname: "/admin/paywalls/[paywallId]/localizable-string-requirement", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/paywalls/[paywallId]/localizable-string-requirement",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/paywalls/[paywallId]/localizable-string-requirement",
    }),
  AdminPaywalls: (query) => ({ 
      pathname: "/admin/paywalls", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/paywalls",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/paywalls",
    }),
  AdminProduct: (query) => ({ 
      pathname: "/admin/products/[productId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/products/[productId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/products/[productId]",
    }),
  AdminProducts: (query) => ({ 
      pathname: "/admin/products", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/products",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/products",
    }),
  AdminShortLink: (query) => ({ 
      pathname: "/admin/short-link/[slug]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/short-link/[slug]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/short-link/[slug]",
    }),
  AdminShortLinks: (query) => ({ 
      pathname: "/admin/short-link", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/short-link",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/short-link",
    }),
  AdminUser: (query) => ({ 
      pathname: "/admin/users/[userId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/users/[userId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/users/[userId]",
    }),
  AdminUserResetPassword: (query) => ({ 
      pathname: "/admin/users/[userId]/reset-password", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/users/[userId]/reset-password",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/users/[userId]/reset-password",
    }),
  AdminUsers: (query) => ({ 
      pathname: "/admin/users", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/users",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/users",
    }),
  UtilsAdminPage: (query) => ({ 
      pathname: "/admin/utils", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/admin/utils",
          Object.keys(query),
          Object.values(query)
        )
      : "/admin/utils",
    }),
  AddExistingApplicationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/add/existing", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/add/existing",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/add/existing",
    }),
  AddApplicationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/add", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/add",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/add",
    }),
  AddApplicationPageMethod: (query) => ({ 
      pathname: "/applications/[applicationId]/add/method", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/add/method",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/add/method",
    }),
  AddNewApplicationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/add/new", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/add/new",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/add/new",
    }),
  ShowArpuPage: (query) => ({ 
      pathname: "/applications/[applicationId]/arpu", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/arpu",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/arpu",
    }),
  ApplicationCampaignPage: (query) => ({ 
      pathname: "/applications/[applicationId]/campaigns/[experimentGroupId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/campaigns/[experimentGroupId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/campaigns/[experimentGroupId]",
    }),
  ShowChartsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/charts", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/charts",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/charts",
    }),
  ShowChartsV2Page: (query) => ({ 
      pathname: "/applications/[applicationId]/charts/v2", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/charts/v2",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/charts/v2",
    }),
  CreateProjectPage: (query) => ({ 
      pathname: "/applications/[applicationId]/create", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/create",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/create",
    }),
  ApplicationETLConfigurationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/etl", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/etl",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/etl",
    }),
  ShowApplicationDashboardPage: (query) => ({ 
      pathname: "/applications/[applicationId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]",
    }),
  LocalizationLocale: (query) => ({ 
      pathname: "/applications/[applicationId]/localization-legacy/[locale]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/localization-legacy/[locale]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/localization-legacy/[locale]",
    }),
  Localization: (query) => ({ 
      pathname: "/applications/[applicationId]/localization-legacy", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/localization-legacy",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/localization-legacy",
    }),
  ApplicationLocalizationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/localization", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/localization",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/localization",
    }),
  InternalPaywallBuilder: (query) => ({ 
      pathname: "/applications/[applicationId]/paywall-builder", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywall-builder",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywall-builder",
    }),
  AppPreview: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/[paywallId]/app-preview", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/[paywallId]/app-preview",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/[paywallId]/app-preview",
    }),
  DuplicatePaywallPage: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/[paywallId]/duplicate", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/[paywallId]/duplicate",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/[paywallId]/duplicate",
    }),
  ShowPaywallPage: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/[paywallId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/[paywallId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/[paywallId]",
    }),
  PaywallLocalizationLocale: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/[paywallId]/localization/[locale]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/[paywallId]/localization/[locale]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/[paywallId]/localization/[locale]",
    }),
  PaywallLocalization: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/[paywallId]/localization", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/[paywallId]/localization",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/[paywallId]/localization",
    }),
  ShowPaywallPageV2: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/[paywallId]/v2", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/[paywallId]/v2",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/[paywallId]/v2",
    }),
  ShowPaywallPageV3: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/[paywallId]/v3", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/[paywallId]/v3",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/[paywallId]/v3",
    }),
  ArchivedPaywallsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/archived", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/archived",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/archived",
    }),
  PaywallsPageClassic: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/classic", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/classic",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/classic",
    }),
  PaywallsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls",
    }),
  NewPaywallPage: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/new", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/new",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/new",
    }),
  NewPaywallPageTemplate: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/new/template", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/new/template",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/new/template",
    }),
  NewPaywallPageV2: (query) => ({ 
      pathname: "/applications/[applicationId]/paywalls/new/v2", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/paywalls/new/v2",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/paywalls/new/v2",
    }),
  ApplicationProducts: (query) => ({ 
      pathname: "/applications/[applicationId]/products", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/products",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/products",
    }),
  ApplicationProductsV2: (query) => ({ 
      pathname: "/applications/[applicationId]/products/v2", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/products/v2",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/products/v2",
    }),
  ShowGettingStartedPage: (query) => ({ 
      pathname: "/applications/[applicationId]/quickstart", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/quickstart",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/quickstart",
    }),
  ApplicationExperimentGroupPage: (query) => ({ 
      pathname: "/applications/[applicationId]/rules/[experimentGroupId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/rules/[experimentGroupId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/rules/[experimentGroupId]",
    }),
  ArchivedExperimentGroupPage: (query) => ({ 
      pathname: "/applications/[applicationId]/rules/archived", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/rules/archived",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/rules/archived",
    }),
  ExperimentGroupPage: (query) => ({ 
      pathname: "/applications/[applicationId]/rules", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/rules",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/rules",
    }),
  ApplicationAdvancedSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/advanced", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/advanced",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/advanced",
    }),
  ApplicationAsaConfigurationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/asa-configuration", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/asa-configuration",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/asa-configuration",
    }),
  ApplicationAscConfigurationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/asc-configuration", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/asc-configuration",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/asc-configuration",
    }),
  ApplicationAssConfigurationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/ass-configuration", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/ass-configuration",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/ass-configuration",
    }),
  ApplicationAuditLogPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/audit-log", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/audit-log",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/audit-log",
    }),
  BillingCardSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/billing/card", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/billing/card",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/billing/card",
    }),
  BillingSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/billing", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/billing",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/billing",
    }),
  ApplicationETLSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/etl", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/etl",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/etl",
    }),
  ApplicationExperimentsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/experiments", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/experiments",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/experiments",
    }),
  ApplicationSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings",
    }),
  ApplicationIntegrationSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/integrations", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/integrations",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/integrations",
    }),
  ApplicationKeysPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/keys", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/keys",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/keys",
    }),
  ApplicationLocalizationProviderPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/localization-legacy", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/localization-legacy",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/localization-legacy",
    }),
  ApplicationLocalizationProviderEditPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/localization-providers/[type]/[projectIdentifier]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/localization-providers/[type]/[projectIdentifier]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/localization-providers/[type]/[projectIdentifier]",
    }),
  ApplciationLocalizationProvidersPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/localization-providers", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/localization-providers",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/localization-providers",
    }),
  ApplicationLocalizationProvidersNewPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/localization-providers/new", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/localization-providers/new",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/localization-providers/new",
    }),
  ApplicationLocalizationConfigureApplication: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/localization-v3", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/localization-v3",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/localization-v3",
    }),
  ApplicationLocalizationPlaceholderPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/localization", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/localization",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/localization",
    }),
  ApplicationOrganizationSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/organization", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/organization",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/organization",
    }),
  ApplicationProjectsSettingsPageV2: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/projects", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/projects",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/projects",
    }),
  ApplicationProjectsSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/projects/legacy", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/projects/legacy",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/projects/legacy",
    }),
  RefundProtectionPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/refund-protection", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/refund-protection",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/refund-protection",
    }),
  ApplicationStripeConfigurationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/stripe-configuration", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/stripe-configuration",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/stripe-configuration",
    }),
  ApplicationTeamSettingsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/settings/team", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/settings/team",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/settings/team",
    }),
  SwagShopPage: (query) => ({ 
      pathname: "/applications/[applicationId]/shop", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/shop",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/shop",
    }),
  ApplicationSurveyEditPage: (query) => ({ 
      pathname: "/applications/[applicationId]/surveys/[surveyId]/edit", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/surveys/[surveyId]/edit",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/surveys/[surveyId]/edit",
    }),
  ApplicationCustomResponsesPage: (query) => ({ 
      pathname: "/applications/[applicationId]/surveys/[surveyId]/responses", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/surveys/[surveyId]/responses",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/surveys/[surveyId]/responses",
    }),
  ApplicationSurveyStatsPage: (query) => ({ 
      pathname: "/applications/[applicationId]/surveys/[surveyId]/stats", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/surveys/[surveyId]/stats",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/surveys/[surveyId]/stats",
    }),
  ApplicationSurveysPage: (query) => ({ 
      pathname: "/applications/[applicationId]/surveys", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/surveys",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/surveys",
    }),
  TemplatesPage: (query) => ({ 
      pathname: "/applications/[applicationId]/templates", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/templates",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/templates",
    }),
  UserV2Page: (query) => ({ 
      pathname: "/applications/[applicationId]/users-v2/[appUserId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/users-v2/[appUserId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/users-v2/[appUserId]",
    }),
  UsersV2Page: (query) => ({ 
      pathname: "/applications/[applicationId]/users-v2", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/users-v2",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/users-v2",
    }),
  UserPage: (query) => ({ 
      pathname: "/applications/[applicationId]/users/[appUserId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/users/[appUserId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/users/[appUserId]",
    }),
  UsersPage: (query) => ({ 
      pathname: "/applications/[applicationId]/users", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/users",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/users",
    }),
  AddWebApplicationPage: (query) => ({ 
      pathname: "/applications/[applicationId]/web/add", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/web/add",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/web/add",
    }),
  Embed: (query) => ({ 
      pathname: "/applications/[applicationId]/web/embed", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/web/embed",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/web/embed",
    }),
  ShowWebApplicationDashboardPage: (query) => ({ 
      pathname: "/applications/[applicationId]/web", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/web",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/web",
    }),
  DuplicateWebPaywallPage: (query) => ({ 
      pathname: "/applications/[applicationId]/web/paywalls/[webPaywallId]/duplicate", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/web/paywalls/[webPaywallId]/duplicate",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/web/paywalls/[webPaywallId]/duplicate",
    }),
  WebPaywallEditorPage: (query) => ({ 
      pathname: "/applications/[applicationId]/web/paywalls/[webPaywallId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications/[applicationId]/web/paywalls/[webPaywallId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications/[applicationId]/web/paywalls/[webPaywallId]",
    }),
  Dashboard: (query) => ({ 
      pathname: "/applications", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/applications",
          Object.keys(query),
          Object.values(query)
        )
      : "/applications",
    }),
  BlogPost: (query) => ({ 
      pathname: "/blog/[slug]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/blog/[slug]",
          Object.keys(query),
          Object.values(query)
        )
      : "/blog/[slug]",
    }),
  Blog: (query) => ({ 
      pathname: "/blog", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/blog",
          Object.keys(query),
          Object.values(query)
        )
      : "/blog",
    }),
  PreviewBlogPost: (query) => ({ 
      pathname: "/blog/preview/[slug]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/blog/preview/[slug]",
          Object.keys(query),
          Object.values(query)
        )
      : "/blog/preview/[slug]",
    }),
  Changelog: (query) => ({ 
      pathname: "/changelog/[slug]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/changelog/[slug]",
          Object.keys(query),
          Object.values(query)
        )
      : "/changelog/[slug]",
    }),
  Index: (query) => ({ 
      pathname: "/changelog", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/changelog",
          Object.keys(query),
          Object.values(query)
        )
      : "/changelog",
    }),
  Page: (query) => ({ 
      pathname: "/contact/[page]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/contact/[page]",
          Object.keys(query),
          Object.values(query)
        )
      : "/contact/[page]",
    }),
  ShowApplicationDashboardPageRedirect: (query) => ({ 
      pathname: "/dashboard/[applicationId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/dashboard/[applicationId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/dashboard/[applicationId]",
    }),
  DashboardRedirect: (query) => ({ 
      pathname: "/dashboard", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/dashboard",
          Object.keys(query),
          Object.values(query)
        )
      : "/dashboard",
    }),
  ForgotPasswordPage: (query) => ({ 
      pathname: "/forgot-password", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/forgot-password",
          Object.keys(query),
          Object.values(query)
        )
      : "/forgot-password",
    }),
  Home: (query) => ({ 
      pathname: "/", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/",
          Object.keys(query),
          Object.values(query)
        )
      : "/",
    }),
  InternalPreview: (query) => ({ 
      pathname: "/internal/paywall-preview/[paywallId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/internal/paywall-preview/[paywallId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/internal/paywall-preview/[paywallId]",
    }),
  InternalPreviewTesting: (query) => ({ 
      pathname: "/internal/paywall-preview/[paywallId]/testing", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/internal/paywall-preview/[paywallId]/testing",
          Object.keys(query),
          Object.values(query)
        )
      : "/internal/paywall-preview/[paywallId]/testing",
    }),
  ShortcutPage: (query) => ({ 
      pathname: "/l/[shortCode]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/l/[shortCode]",
          Object.keys(query),
          Object.values(query)
        )
      : "/l/[shortCode]",
    }),
  LoginPage: (query) => ({ 
      pathname: "/login", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/login",
          Object.keys(query),
          Object.values(query)
        )
      : "/login",
    }),
  Authorizate: (query) => ({ 
      pathname: "/oauth/authorize", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/oauth/authorize",
          Object.keys(query),
          Object.values(query)
        )
      : "/oauth/authorize",
    }),
  AndroidBetaPage: (query) => ({ 
      pathname: "/onboarding/android-beta", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/onboarding/android-beta",
          Object.keys(query),
          Object.values(query)
        )
      : "/onboarding/android-beta",
    }),
  AppExistsPage: (query) => ({ 
      pathname: "/onboarding/app-exists", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/onboarding/app-exists",
          Object.keys(query),
          Object.values(query)
        )
      : "/onboarding/app-exists",
    }),
  ComingSoonPage: (query) => ({ 
      pathname: "/onboarding/coming-soon", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/onboarding/coming-soon",
          Object.keys(query),
          Object.values(query)
        )
      : "/onboarding/coming-soon",
    }),
  FlutterPage: (query) => ({ 
      pathname: "/onboarding/flutter", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/onboarding/flutter",
          Object.keys(query),
          Object.values(query)
        )
      : "/onboarding/flutter",
    }),
  OnboardingNewApplicationPage: (query) => ({ 
      pathname: "/onboarding/new-application", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/onboarding/new-application",
          Object.keys(query),
          Object.values(query)
        )
      : "/onboarding/new-application",
    }),
  ReactNativePage: (query) => ({ 
      pathname: "/onboarding/react-native", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/onboarding/react-native",
          Object.keys(query),
          Object.values(query)
        )
      : "/onboarding/react-native",
    }),
  New: (query) => ({ 
      pathname: "/paywalls/new", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/paywalls/new",
          Object.keys(query),
          Object.values(query)
        )
      : "/paywalls/new",
    }),
  DPA: (query) => ({ 
      pathname: "/privacy/dpa", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/privacy/dpa",
          Object.keys(query),
          Object.values(query)
        )
      : "/privacy/dpa",
    }),
  GDPR: (query) => ({ 
      pathname: "/privacy/gdpr", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/privacy/gdpr",
          Object.keys(query),
          Object.values(query)
        )
      : "/privacy/gdpr",
    }),
  Privacy: (query) => ({ 
      pathname: "/privacy", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/privacy",
          Object.keys(query),
          Object.values(query)
        )
      : "/privacy",
    }),
  SubProcessors: (query) => ({ 
      pathname: "/privacy/subprocessors", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/privacy/subprocessors",
          Object.keys(query),
          Object.values(query)
        )
      : "/privacy/subprocessors",
    }),
  Terms: (query) => ({ 
      pathname: "/privacy/terms", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/privacy/terms",
          Object.keys(query),
          Object.values(query)
        )
      : "/privacy/terms",
    }),
  RequestTemplatePage: (query) => ({ 
      pathname: "/request-template", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/request-template",
          Object.keys(query),
          Object.values(query)
        )
      : "/request-template",
    }),
  ResetPasswordPage: (query) => ({ 
      pathname: "/reset-password", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/reset-password",
          Object.keys(query),
          Object.values(query)
        )
      : "/reset-password",
    }),
  SelectApplicationPage: (query) => ({ 
      pathname: "/select-application", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/select-application",
          Object.keys(query),
          Object.values(query)
        )
      : "/select-application",
    }),
  SelectOrganization: (query) => ({ 
      pathname: "/select-organization", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/select-organization",
          Object.keys(query),
          Object.values(query)
        )
      : "/select-organization",
    }),
  Settings: (query) => ({ 
      pathname: "/settings", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/settings",
          Object.keys(query),
          Object.values(query)
        )
      : "/settings",
    }),
  ShareTemplatePage: (query) => ({ 
      pathname: "/share/t/[templateId]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/share/t/[templateId]",
          Object.keys(query),
          Object.values(query)
        )
      : "/share/t/[templateId]",
    }),
  SignupPage: (query) => ({ 
      pathname: "/signup", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/signup",
          Object.keys(query),
          Object.values(query)
        )
      : "/signup",
    }),
  TemplateDuplicatePaywallPage: (query) => ({ 
      pathname: "/templates/[templateId]/duplicate", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/templates/[templateId]/duplicate",
          Object.keys(query),
          Object.values(query)
        )
      : "/templates/[templateId]/duplicate",
    }),
  Templates: (query) => ({ 
      pathname: "/templates", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/templates",
          Object.keys(query),
          Object.values(query)
        )
      : "/templates",
    }),
  PaywallTriggerPage: (query) => ({ 
      pathname: "/triggers/[eventName]", 
      query,
      href: query
      ? replaceSlugsWithValues(
          "/triggers/[eventName]",
          Object.keys(query),
          Object.values(query)
        )
      : "/triggers/[eventName]",
    })
}
function replaceSlugsWithValues(str, slugs, values) {
      let result = str;
      slugs.forEach((slug, i) => {
          const value = values[i];
          if (value) {
              result = result.replace('[' + slug + ']', String(value));
          }
      });
      return result;
    }